import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage/HomePage';
import PlayerDetail from './components/PlayerDetail/PlayerDetail';
import MapPage from './components/MapPage/MapPage';
import './App.scss';

function AppContent() {
    const location = useLocation();

    const getPageClassName = () => {
        if (location.pathname === '/') return 'page-home';
        if (location.pathname === '/map') return 'page-map';
        if (location.pathname.startsWith('/') && location.pathname !== '/') return 'page-player-detail';
        return '';
    };

    return (
        <div className={`App ${getPageClassName()}`}>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/:playerId" element={<PlayerDetail />} />
            </Routes>
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;